import { useAuth0 } from '@auth0/auth0-react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import { useEffect, useState } from 'react';

export const useNewGlobalLoadingState = () => {
  const { isLoading: isAuth0Loading } = useAuth0();
  const [showIndicator, setShowIndicator] = useState(false);

  const isFetching = useIsFetching({
    // We check status here to avoid displaying the indicator on refetches
    predicate: (query) => query.state.status === 'pending' && Boolean(query.meta?.showGlobalLoader),
  });
  const isMutating = useIsMutating({
    predicate: (mutation) =>
      mutation.state.status === 'pending' && Boolean(mutation.meta?.showGlobalLoader),
  });

  // We can potentially use the meta object to provide a label to the loader here
  const what = '';

  const isLoading = isFetching > 0 || isMutating > 0 || isAuth0Loading;

  useEffect(() => {
    if (!isLoading) {
      setShowIndicator(false);
      return undefined;
    }

    const showTimeout = window.setTimeout(() => setShowIndicator(true), 200);

    return () => {
      window.clearTimeout(showTimeout);
    };
  }, [isLoading]);

  return { showIndicator, what };
};
